import request from './request'

// 规格（维度）选项：GET /admin/specs/options -> { data: { specs: [...], statuses } }
export const getSpecOptions = () => request({ url: '/admin/specs/options', method: 'get' })

// 规格值选项：GET /admin/spec-values/options -> { data: { spec_values: [...], statuses } }
export const getSpecValueOptions = () => request({ url: '/admin/spec-values/options', method: 'get' })

// 规格（维度）列表：GET /admin/specs
export const getSpecs = (params = {}) => request({ url: '/admin/specs', method: 'get', params })

// 创建规格（维度）：POST /admin/specs { name, sort, status }
export const createSpec = (data) => request({ url: '/admin/specs', method: 'post', data })

// 更新规格（维度）：PUT /admin/specs/{id}
export const updateSpec = (id, data) => request({ url: `/admin/specs/${id}`, method: 'put', data })

// 删除规格（维度）：DELETE /admin/specs/{id}
export const deleteSpec = (id) => request({ url: `/admin/specs/${id}`, method: 'delete' })

// 规格值列表：GET /admin/spec-values
export const getSpecValues = (params = {}) => request({ url: '/admin/spec-values', method: 'get', params })

// 创建规格值：POST /admin/spec-values { spec_id, name, sort, status }
export const createSpecValue = (data) => request({ url: '/admin/spec-values', method: 'post', data })

// 更新规格值：PUT /admin/spec-values/{id}
export const updateSpecValue = (id, data) => request({ url: `/admin/spec-values/${id}`, method: 'put', data })

// 删除规格值：DELETE /admin/spec-values/{id}
export const deleteSpecValue = (id) => request({ url: `/admin/spec-values/${id}`, method: 'delete' })

// 商品-规格关联列表：GET /admin/product-specs?product_id=
export const getProductSpecs = (productId, params = {}) =>
  request({ url: '/admin/product-specs', method: 'get', params: { product_id: productId, pageSize: 100, ...params } })

// 创建商品-规格关联：POST /admin/product-specs { product_id, spec_id }
export const createProductSpec = (productId, specId) =>
  request({ url: '/admin/product-specs', method: 'post', data: { product_id: productId, spec_id: specId } })

// 删除商品-规格关联：DELETE /admin/product-specs/{id}
export const deleteProductSpec = (id) =>
  request({ url: `/admin/product-specs/${id}`, method: 'delete' })

// SKU-规格值关联列表：GET /admin/sku-specs?sku_id=
export const getSkuSpecs = (skuId, params = {}) =>
  request({ url: '/admin/sku-specs', method: 'get', params: { sku_id: skuId, pageSize: 100, ...params } })

// 创建 SKU-规格值关联：POST /admin/sku-specs { sku_id, spec_value_id }
export const createSkuSpec = (skuId, specValueId) =>
  request({ url: '/admin/sku-specs', method: 'post', data: { sku_id: skuId, spec_value_id: specValueId } })

// 删除 SKU-规格值关联：DELETE /admin/sku-specs/{id}
export const deleteSkuSpec = (id) =>
  request({ url: `/admin/sku-specs/${id}`, method: 'delete' })
